import { PHRASES } from "../lib/api";

export default function Marquee() {
  const items = [...PHRASES, ...PHRASES];
  return (
    <div className="w-full overflow-hidden border-y border-white/10 py-8 bg-[#070707]" data-testid="brand-marquee">
      <div className="mm-marquee-track">
        {items.map((p, i) => (
          <span key={i} className="inline-flex items-center">
            <span className="font-serif italic text-3xl md:text-5xl text-white/70 px-10">
              {p}
            </span>
            <span className="text-gold text-2xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
